import { createStore } from 'vuex'

export default createStore({
    state: {
        // User & Auth
        msisdn: undefined,
        serviceId: undefined,
        user: undefined,
        token: undefined,
        encryptedMsisdn: undefined,

        // Brand & Config
        brandConfig: undefined,
        productId: 56, // LeagueXI product ID
        myBundle: sessionStorage.getItem('myBundle') === 'true',

        // UI State
        isLoading: undefined,
        showEditUserName: false,
        showEditAvatar: false,
        showUnsubPopup: false,
        showAddToHomeScreen: false,
        deferredPrompt: null,

        // Trivia State
        showTriviaGameOver: false,
        showHint: false,
        showNoQuestions: false,
        triviaUserStats: undefined,
        currentQuestion: undefined,

        // Predictor State
        predictorUserStats: undefined,
        upcomingFixtures: [],
        roundId: undefined,
        leagueName: undefined,
        liveRoundsNotEntered: 0,
        roundsEntered: 0,

        // Fantasy State - commented out for Lite Version (uncomment to re-enable)
        // fantasyActiveRounds: undefined,
        // fantasyRoundSelected: undefined,
        // fantasyUserLandingStats: undefined,
        // fantasyRoundHasFullTeam: false,
        // fantasyCaptainSelectPopup: false,

        // News
        feedArticles: [],

        // Campaign tracking
        campaignId: 0,
        googleClickId: undefined,
        clickId: undefined,
    },
    mutations: {
        // User & Auth
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        },
        setMyBundle(state, myBundle) {
            state.myBundle = myBundle
            sessionStorage.setItem('myBundle', myBundle ? 'true' : 'false')
        },
        setServiceId(state, serviceId) {
            state.serviceId = serviceId
        },
        setUser(state, user) {
            state.user = user
        },
        setToken(state, token) {
            state.token = token
        },
        setEncryptedMsisdn(state, encryptedMsisdn) {
            state.encryptedMsisdn = encryptedMsisdn
        },

        // Brand & Config
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
        },

        // UI State
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setShowEditUserName(state, showEditUserName) {
            state.showEditUserName = showEditUserName
        },
        setShowEditAvatar(state, showEditAvatar) {
            state.showEditAvatar = showEditAvatar
        },
        setShowUnsubPopup(state, showUnsubPopup) {
            state.showUnsubPopup = showUnsubPopup
        },
        setShowAddToHomeScreen(state, showAddToHomeScreen) {
            state.showAddToHomeScreen = showAddToHomeScreen
        },
        setDeferredPrompt(state, deferredPrompt) {
            state.deferredPrompt = deferredPrompt
        },

        // Trivia State
        setShowTriviaGameOver(state, showTriviaGameOver) {
            state.showTriviaGameOver = showTriviaGameOver
        },
        setShowHint(state, showHint) {
            state.showHint = showHint
        },
        setShowNoQuestions(state, showNoQuestions) {
            state.showNoQuestions = showNoQuestions
        },
        setTriviaUserStats(state, triviaUserStats) {
            state.triviaUserStats = triviaUserStats
        },
        setCurrentQuestion(state, currentQuestion) {
            state.currentQuestion = currentQuestion
        },

        // Predictor State
        setPredictorUserStats(state, predictorUserStats) {
            state.predictorUserStats = predictorUserStats
        },
        setUpcomingFixtures(state, upcomingFixtures) {
            state.upcomingFixtures = upcomingFixtures
        },
        setRoundId(state, roundId) {
            state.roundId = roundId
        },
        setLeagueName(state, leagueName) {
            state.leagueName = leagueName
        },
        setLiveRoundsNotEntered(state, liveRoundsNotEntered) {
            state.liveRoundsNotEntered = liveRoundsNotEntered
        },
        setRoundsEntered(state, roundsEntered) {
            state.roundsEntered = roundsEntered
        },

        // News
        setFeedArticles(state, feedArticles) {
            state.feedArticles = feedArticles
        },

        // Fantasy State - commented out for Lite Version (uncomment to re-enable)
        // setFantasyActiveRounds(state, rounds) {
        //     state.fantasyActiveRounds = rounds
        // },
        // setFantasyRoundSelected(state, round) {
        //     state.fantasyRoundSelected = round
        // },
        // setFantasyUserLandingStats(state, stats) {
        //     state.fantasyUserLandingStats = stats
        // },
        // setFantasyRoundHasFullTeam(state, hasFullTeam) {
        //     state.fantasyRoundHasFullTeam = hasFullTeam
        // },
        // setFantasyCaptainSelectPopup(state, show) {
        //     state.fantasyCaptainSelectPopup = show
        // },
        // setFantasySelectedPosition(state, position) {
        //     if (state.fantasyRoundSelected) {
        //         state.fantasyRoundSelected.selectedPosition = position
        //     }
        // },
        // setFantasyForwardPick(state, player) {
        //     if (state.fantasyRoundSelected) {
        //         if (!state.fantasyRoundSelected.selections) state.fantasyRoundSelected.selections = {}
        //         state.fantasyRoundSelected.selections.forward = player
        //     }
        // },
        // setFantasyMidfielderOnePick(state, player) {
        //     if (state.fantasyRoundSelected) {
        //         if (!state.fantasyRoundSelected.selections) state.fantasyRoundSelected.selections = {}
        //         state.fantasyRoundSelected.selections.midfielder1 = player
        //     }
        // },
        // setFantasyMidfielderTwoPick(state, player) {
        //     if (state.fantasyRoundSelected) {
        //         if (!state.fantasyRoundSelected.selections) state.fantasyRoundSelected.selections = {}
        //         state.fantasyRoundSelected.selections.midfielder2 = player
        //     }
        // },
        // setFantasyDefencePick(state, player) {
        //     if (state.fantasyRoundSelected) {
        //         if (!state.fantasyRoundSelected.selections) state.fantasyRoundSelected.selections = {}
        //         state.fantasyRoundSelected.selections.defence = player
        //     }
        // },
        // setFantasyGoalkeeperPick(state, player) {
        //     if (state.fantasyRoundSelected) {
        //         if (!state.fantasyRoundSelected.selections) state.fantasyRoundSelected.selections = {}
        //         state.fantasyRoundSelected.selections.goalkeeper = player
        //     }
        // },
        // clearFantasyMidfielders(state) {
        //     if (state.fantasyRoundSelected?.selections) {
        //         state.fantasyRoundSelected.selections.midfielder1 = undefined
        //         state.fantasyRoundSelected.selections.midfielder2 = undefined
        //     }
        // },
        // updateFantasyRoundsEntered(state) {
        //     if (state.fantasyUserLandingStats) {
        //         state.fantasyUserLandingStats.roundsEntered = (state.fantasyUserLandingStats.roundsEntered || 0) + 1
        //     }
        // },

        // Campaign tracking
        setCampaignId(state, campaignId) {
            state.campaignId = campaignId
        },
        setGoogleClickId(state, googleClickId) {
            state.googleClickId = googleClickId
        },
        setClickId(state, clickId) {
            state.clickId = clickId
        },
    },
})
